import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "onlyoffice"
}

import { useUserStore } from '@/store/modules/user';
import { DocumentEditor } from "@onlyoffice/document-editor-vue";


export default {
  __name: 'Document',
  props: {
  documentKey: {
    type: String,
    default: () => ''
  },
  documentUrl: {
    type: String,
    default: () => ''
  }
},
  setup(__props) {

const documentServerUrl = computed(() => {
  return process.env.VUE_APP_DOCUMENT_SERVER
})
const userStore = useUserStore()

const props = __props

const config = computed(() => ({
  documentType: "word",
  type: "desktop",
  document: {
    fileType: "docx",
    key: `${props.documentKey || 'doc-key'}-${new Date().getTime()}`, // 项目id
    title: "在线批注文档",
    url: props.documentUrl,
    permissions: {
      chat: false,
      edit: false,            // 不允许编辑正文
      comment: true,          // 允许批注
      fillForms: false,
      download: false,
      print: false,
      review: false,
      copy: false,
      rename: false,
      deleteComment: true     // 可删除自己的批注
    }
  },
  // token: 'FYFVRC6nJHsk11fxpjpFsp9aYHHbfkyv',
  editorConfig: {
    mode: "edit",               // 必须是 edit 才能允许添加批注
    lang: "zh-CN",
    user: {
      id: userStore.userInfo.id,
      name: userStore.userInfo.realname || '匿名'
    },
    callbackUrl: process.env.VUE_APP_SERVICE_URL + "/system/onlyoffice/callback", // 文档保存回调地址（可选）
    customization: {
      about: false,
      feedback: false,
      compactHeader: true,
      hideRightMenu: true,
      autoSave: true,
      toolbarHide: true,
      help: false,
      plugins: false,
      forcesave: true
    }
  },
}))


const onDocumentReady = () => {
  console.log("Document is loaded");
}
const onLoadComponentError = (errorCode, errorDescription) => {
  switch(errorCode) {
    case -1: // Unknown error loading component
      console.log(errorDescription);
      break;

    case -2: // Error load DocsAPI from http://documentserver/
      console.log(errorDescription);
      break;

    case -3: // DocsAPI is not defined
      console.log(errorDescription);
      break;
  }
}

return (_ctx, _cache) => {
  return (__props.documentUrl)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(DocumentEditor), {
          id: "docEditor",
          documentServerUrl: _unref(documentServerUrl),
          config: _unref(config),
          events_onDocumentReady: onDocumentReady,
          onLoadComponentError: onLoadComponentError
        }, null, 8, ["documentServerUrl", "config"])
      ]))
    : _createCommentVNode("", true)
}
}

}